/* eslint-disable import/no-unresolved */
import { Button } from "@mui/material";
import { useMutation, useQuery } from "react-query";
import customerDeclaration from "src/services/reviewDetails";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useEffect, useState } from "react";
import CustomSuccessModal from "src/shared/CustomSuccessModal";
import { useFormik } from "formik";
import {
  IProposalPayment,
  validationSchema
} from "src/helpers/FormDetails/ReviewDetails/ProposalPayment";
import { useDispatch } from "react-redux";
import { setMefUploadModal } from "src/redux/Actions/common";
import { getReviewDetails } from "src/services/LeadInfo";
import store from "src/redux/store";
import { setReviewDetails } from "src/redux/Thunk";
import CustomLoader from "src/shared/CustomLoader";
import { EInsurerType } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { getFullName } from "src/helpers/FormDetails/ProposalDetails/resources";
import { MasterAction } from "src/redux/Actions/Masters";
import { SET_MEF_JOURNEY_SCHEMA } from "src/redux/Types/Masters";
import ProposalOtp from "./ProposalOtp";
import VerifyOtpReviewDetails from "./VerifyOtpReviewDetails";

interface Props {
  insurerType: EInsurerType;
}

function ReviewDetails({ insurerType }: Props) {
  const leadId = useAppSelector((state) => state.common.leadId);
  const modalState = useAppSelector((state) => state.mefUploadModal.modalState);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const verifyOtpLeadId = useAppSelector((state) => state.verifyOtpLeadId.leadId);
  const [showModal, setShowModal] = useState(false || modalState);
  const generalDetails: any = useAppSelector((state) => state.proposerDetails.general);
  const dispatch = useDispatch();
  const { mutate: mutateCustomerDeclaration } = useMutation(customerDeclaration, {
    onSuccess: () => {
      setShowModal(true);
      dispatch(setMefUploadModal({ modalState: true }));
    }
  });

  const { isFetching: isReviewLeadFetching, isError: isGetReviewError } = useQuery(
    ["getReviewDetails"],
    () => getReviewDetails(leadId || ""),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!leadId,
      onSuccess: (response) => {
        store.dispatch(setReviewDetails(response.data, leadId || ""));

        const mefSchema = response?.data?.RuleEngine.mefValidations;
        if (mefSchema) {
          dispatch(MasterAction(SET_MEF_JOURNEY_SCHEMA, mefSchema));
        }
      }
    }
  );

  const today = new Date();
  const day = today.getDate().toString().padStart(2, "0");
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const year = today.getFullYear();
  const { firstName, middleName, lastName } = generalDetails || {};

  const initialValues: IProposalPayment = {
    nameofPolicyHolder: getFullName(firstName, middleName, lastName),
    place: "",
    date: `${day}/${month}/${year}`,
    signature: "",
    declaration: ""
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues,
    validationSchema: validationSchema(),
    onSubmit: (fieldValues) => {
      mutateCustomerDeclaration({
        leadId: verifyOtpLeadId,
        name: fieldValues.nameofPolicyHolder,
        place: fieldValues.place,
        insurerType: { insurerType }
      });
    }
  });

  useEffect(() => {
    const isFormValid =
      formik.values.date !== "" &&
      formik.values.declaration &&
      formik.values.nameofPolicyHolder !== "" &&
      formik.values.place !== "";

    setIsButtonDisabled(!isFormValid);
  }, [formik.values]);

  if (isReviewLeadFetching) {
    return <CustomLoader />;
  }

  if (isGetReviewError) {
    return <div className="text-center mt-20 text-2xl font-bold text-hotShot">No Data Found</div>;
  }
  return (
    <div>
      {showModal && (
        <CustomSuccessModal
          shortMessage="Successful"
          longMessage="Your MEF has been submitted."
          isButtonEnable={false}
        />
      )}
      <div className=" bg-whiteSmoke pt-8 mx-auto">
        <ProposalOtp insurerType={insurerType} />
        <VerifyOtpReviewDetails formik={formik} insurerType={insurerType} />
        <div className="mx-auto xl:w-290 w-auto mt-6 rounded-lg flex justify-center pb-4 pt-4 bg-white">
          <Button
            variant="outlined"
            className="!uppercase h-13 rounded-lg !mr-10"
            onClick={() => window.scrollTo(0, 0)}
          >
            BACK TO TOP
          </Button>
          <form onSubmit={formik.handleSubmit}>
            <Button
              disabled={isButtonDisabled}
              type="submit"
              variant="contained"
              className="!uppercase h-13  rounded-lg"
            >
              SUBMIT
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ReviewDetails;
